export const HOME_INSTALLMENT_FILTER = { DELAYED: "delayed", AHEAD: "ahead" } as const;
export type HOME_INSTALLMENT_FILTER = (typeof HOME_INSTALLMENT_FILTER)[keyof typeof HOME_INSTALLMENT_FILTER];
